/**
 * Shared helpers for turning /api/... `jumbled_bundles` payload into synthetic
 * NotificationBroadcastModal entries. Called from PickingPortal, PressingOrderBoard,
 * and QCPortal so the modal renders identically across all three.
 *
 * Backend contract: order.jumbled_bundles = [{group_id, label, fo_count,
 *   fos:[{fo_id, location_name, items:[{title, sku, quantity}]}]}]
 */

export function synthesizeJumbledBundleNotifications(jumbledBundles, orderName) {
    const list = Array.isArray(jumbledBundles) ? jumbledBundles : [];
    if (list.length === 0) return [];

    return list.map((jb) => {
        const fos = Array.isArray(jb.fos) ? jb.fos : [];
        // Plain-text fallback (also used by any old code path that renders
        // `n.message` as-is). The modal reads `_jumbled` when scope matches.
        const locSummary = fos.map((f) => {
            const qty = (f.items || []).reduce((s, it) => s + (it.quantity || 0), 0);
            return `${f.location_name || '(unknown)'}: ${qty} ${qty === 1 ? 'item' : 'items'}`;
        }).join('\n');
        const detail = fos.map((f) => {
            const header = `${f.location_name || '(unknown)'}:`;
            const lines = (f.items || []).map((it) => `  ${it.quantity}× ${it.title}`);
            return [header, ...lines].join('\n');
        }).join('\n\n');
        const suffix = jb.player_suffix ? ` ${jb.player_suffix}` : '';
        const message =
            `Bundle:\n"${jb.label}"${suffix}\n\n` +
            `${locSummary}\n\n` +
            detail;

        return {
            id: `jumbled_bundle:${jb.group_id}`,
            scope: 'jumbled_bundle',
            order_name: orderName || null,
            club_name:  null,
            message,
            _jumbled: jb,   // Structured payload — NotificationBroadcastModal renders it richly.
        };
    });
}
